import { render, staticRenderFns } from "./RemoveUsersCalendars.vue?vue&type=template&id=5f0d8f58"
import script from "./RemoveUsersCalendars.vue?vue&type=script&lang=js"
export * from "./RemoveUsersCalendars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports